import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { dispatch } from '@ngxs/store';
import { DRAWER_DATA } from 'src/app/ui/drawer/drawer-data.token';
import { UiModule } from 'src/app/ui/ui.module';
import { ESigningCanvasComponent } from '../../envelope-draft/e-signing-canvas/e-signing-canvas.component';
import { FileDownloadActions } from 'src/app/shared/state/file-download/fileDownload.index';
import { downloadEnvelopePdf } from '@core/util/file';
import { ToastService } from 'src/app/ui/toast/toast.service';
import { Logger } from '@core/logger';

@Component({
	selector: 'app-view-envelope-drawer',
	imports: [CommonModule, UiModule, ESigningCanvasComponent],
	templateUrl: './view-envelope-drawer.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewEnvelopeDrawerComponent {
	private drawerData = inject(DRAWER_DATA);
	private downloadFile = dispatch(FileDownloadActions.DownloadFile);
	private toastService = inject(ToastService);

	public pages = this.drawerData?.pages ?? [];
	public blocks = this.drawerData?.blocks ?? [];
	public recipients = this.drawerData?.recipients ?? [];
	public pdfUrl = this.drawerData?.pdfUrl;
	public fileName = this.drawerData?.fileName;

	public async downloadPdf(): Promise<void> {
		if (!this.pdfUrl || !this.fileName) {
			Logger.error(
				'ViewEnvelopeDrawer: Cannot download - missing PDF URL or filename',
			);
			this.toastService.error(
				'Unable to download document. Document not available.',
			);
			return;
		}

		try {
			await downloadEnvelopePdf(this.pdfUrl, this.fileName, this.downloadFile);
		} catch (error) {
			Logger.error(`ViewEnvelopeDrawer: Error downloading PDF: ${error}`);
			this.toastService.error('Failed to download document. Please try again.');
		}
	}
}
